export enum CourseCardState {
  BASIC = 'basic',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed'
}
